module.exports = __webpack_public_path__ + "img/tips-gps.57791503.svg";